import React, {useEffect, useState} from "react";
import {
    Button, Col, Row, Form, Tabs, Input, Card, Select, message, Space, Typography
} from 'antd';
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {useNavigate} from "react-router-dom";
import {
    getLanguages,
    addNewSitePages,
    addNewUrl,
    searchUrl,
    searchPageID,
    getSidebars,
    addSitePagesHistory
} from "../../service";
import {EmptyLanguage} from "../../layout/errorMessage";
import CodeMirror from "@uiw/react-codemirror";
import {javascript} from "@codemirror/lang-javascript";
import {html} from "@codemirror/lang-html";

export default function CreateSitePages() {

    const [languageList, setLanguageList] = useState(false);
    const [friendlyURL, setFriendlyURL] = useState(false);
    const [friendlyURLInvalid, setFriendlyURLInvalid] = useState(false);
    const [pageIDs, setPageID] = useState("");
    const [pageIDInvalid, setPageIDInvalid] = useState(false);
    const [sidebarList, setSidebarList] = useState(false);
    const [javascriptCount, setJavascriptCount] = useState([]);
    const [javascriptCountStatus, setJavascriptCountStatus] = useState("");
    const navigate = useNavigate();
    const {TextArea} = Input;
    const {Option} = Select;
    const {Text, Link} = Typography;
    const [formRef] = Form.useForm();
    const pushLanguagesData = async (item, values) => {

        let custom = {}
        let title = {}
        let metaDescription = {}
        let metaKeywords = {}

        //custom
        var customClass = "detail-" + item.code
        var customDetails = {
            language: item.code,
            details: values[customClass],
        }
        custom = customDetails

        //title
        var titleClass = "title-" + item.code
        var titleDetails = {
            language: item.code,
            title: values[titleClass],
        }
        title = titleDetails

        //Meta Description
        var descriptionClass = "seoDescription-" + item.code
        var descriptionDetails = {
            language: item.code,
            description: values[descriptionClass],
        }
        metaDescription = descriptionDetails;

        var keywordsClass = "seoKeyword-" + item.code
        var keywordsDetails = {
            language: item.code,
            keywords: values[keywordsClass],
        }
        metaKeywords = keywordsDetails;

        return {custom, metaDescription, metaKeywords, title}
    }

    const onFinish = async (values) => {

        let CustomDetails = [];
        let MetaDescription = [];
        let MetaKeywords = [];
        let titles = [];

        await Promise.all(languageList.list.map((item, index) => pushLanguagesData(item, values))).then((res) => {

            res.map((v, i) => {
                CustomDetails.push(v.custom)
                MetaDescription.push(v.metaDescription)
                MetaKeywords.push(v.metaKeywords)
                titles.push(v.title)
            })
        })

        let urlStatus;
        let defaultUrl;

        do {
            defaultUrl = "/sites/" + Math.floor(Math.random() * 9999);
            searchUrl({
                path: defaultUrl
            }).then((res) => {
                if (res === null) {
                    urlStatus = "not used"
                } else {
                    urlStatus = "used"
                }
            })

        } while (urlStatus === "used")

        addSitePagesHistory({
            title: titles,
            sidebarID: values.sidebarID,
            pageID: pageIDs,
            details: CustomDetails,
            script: values.script,
            scripts: values.scripts,
            metaDescription: MetaDescription,
            metaKeywords: MetaKeywords,
        }).then(async (history) => {
            let historyIds = [];
            let timeStamp = Math.round((new Date()).getTime() / 1000);
            let date = new Date(timeStamp * 1000)
            await historyIds.push({
                timestamp: timeStamp,
                dateTime: date.toLocaleDateString("en-US") + " " + date.toLocaleTimeString("en-US"),
                id: history._id,
                message: "Initial Commit"
            })
            addNewSitePages(
                {
                    title: titles,
                    sidebarID: values.sidebarID ? values.sidebarID : "0",
                    dynamicPath: "/" + friendlyURL,
                    defaultPath: defaultUrl,
                    pageID: pageIDs,
                    details: CustomDetails,
                    script: values.script,
                    scripts: values.scripts,
                    metaDescription: MetaDescription,
                    metaKeywords: MetaKeywords,
                    historyIDs: historyIds,
                    historyID: history._id
                }
            ).then((res) => {

                if (values.seoUrl !== undefined) {
                    addNewUrl({
                        path: "/" + values.seoUrl,
                        type: "Site Pages",
                        referralID: res._id,
                    })
                }

                addNewUrl({
                    path: defaultUrl,
                    type: "Site Pages",
                    referralID: res._id,
                })

                navigate(-1)
                message.success('Site page created successfully');
            })
        })

    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        errorInfo.errorFields && errorInfo.errorFields.map((err)=>{
            message.error(err.errors)
        })

    };

    const dispatchLanguages = () => {
        getLanguages().then(async (response) => {
            setLanguageList(response)
        });
    };

    const dispatchSidebars = () => {
        getSidebars().then(async (response) => {
            setSidebarList(response)
        });
    };

    const handleFriendlyUrl = (e) => {
        let friendlyURL = e.target.value.toLowerCase()
            .replace(/ /g, '-').replace(/[-]+/g, '-')
            .replace(/[^\w-]+/g, '')

        setFriendlyURL(friendlyURL)

        searchUrl({
            path: "/" + friendlyURL
        }).then((res) => {
            if (res === null) {
                setFriendlyURLInvalid(false)
            } else {
                setFriendlyURLInvalid(true)
            }
        })
    }

    const handlePageID = (e) => {
        let pageID = e.target.value.toLowerCase()
            .replace(/ /g, '-').replace(/[-]+/g, '-')
            .replace(/[^\w-]+/g, '');

        searchPageID({pageID: pageID}).then((res) => {
            if (res !== null) {
                setPageIDInvalid(true)
            } else {
                setPageIDInvalid(false)
            }
        })

        setPageID(pageID)
    }

    const handleJavascriptCount = async () => {
        let jsTextarea = document.getElementsByClassName("jsTextarea");
        let ary = []
        let status = [];
        for (let i = 0; i < jsTextarea.length; i++) {
            let currentData = formRef.getFieldsValue(true);
            let jsLength = currentData.scripts[i].length
            ary.push({
                className: "jsTextarea-" + i,
                length: jsLength,
                status: jsLength > 10000 ? "error" : true,
                maxLength: 10000
            })
            if (jsLength > 10000) {
                status.push("error")
            }

        }
        if (status.length > 0) {
            setJavascriptCountStatus("error")
        } else {
            setJavascriptCountStatus("")
        }
        setJavascriptCount(ary)
        console.log(ary)
    }

    useEffect(() => {
        dispatchLanguages();
        dispatchSidebars();
    }, []);


    return (
        <>
            <div className="sitepages">
                <div className="site-layout-background">
                    <Form
                        name="siteCreate"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        form={formRef}
                    >
                        <Row>
                            <Col span={12}>
                                <h3>New Site Pages</h3>
                            </Col>
                            <Col span={12} className="text-end">
                                <Button type="primary" shape="round" htmlType="submit"
                                        disabled={friendlyURLInvalid === true || pageIDInvalid === true ? true : false || javascriptCountStatus === "error"}>
                                    Save Changes
                                </Button>
                                <Button shape="round" className="ms-2" onClick={() => navigate(-1)}>
                                    Back
                                </Button>
                            </Col>
                        </Row>

                        {languageList.status === 200 && languageList.list.length > 0 ? (
                            <Col>
                                <Tabs>
                                    <Tabs.TabPane tab={"General"} key={1} forceRender={true}>

                                        <Row gutter={[16, 16]}>
                                            <Col span={12}>
                                                <div className="mb-2">
                                                    <Col className="mb-2">
                                                        PageID:
                                                    </Col>
                                                    <Col>
                                                        <Form.Item
                                                            name="pageID"
                                                            validateStatus={pageIDInvalid === true ? "error" : ""}
                                                            help={pageIDs !== "" ? pageIDInvalid === true ? "PageID is already in use" : "Your Page ID is " + pageIDs : ""}
                                                        >
                                                            <Input onKeyUp={handlePageID}/>
                                                        </Form.Item>
                                                    </Col>
                                                </div>
                                                <div className="mb-2">
                                                    <Col className="mb-2">
                                                        Sidebar:
                                                    </Col>
                                                    <Col>
                                                        {sidebarList && sidebarList ? (
                                                            <Form.Item name="sidebarID">
                                                                <Select
                                                                    placeholder="Select an option"
                                                                    allowClear
                                                                >
                                                                    <Option value="0">No Sidebar</Option>
                                                                    {
                                                                        sidebarList && sidebarList.map((page, index) => (
                                                                            <Option value={page._id}
                                                                                    key={index + 1}>{page.title}</Option>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </Form.Item>
                                                        ) : ""}
                                                    </Col>
                                                </div>
                                                <div className="mb-2">
                                                    <Col className="mb-2">
                                                        Friendly URL:
                                                    </Col>
                                                    <Col>
                                                        <Form.Item
                                                            name="seoUrl"
                                                            validateStatus={friendlyURLInvalid === true ? "error" : ""}
                                                            help={friendlyURLInvalid === true ? "This URL is already in use" : ""}
                                                        >
                                                            <Input onKeyUp={handleFriendlyUrl}/>
                                                        </Form.Item>
                                                    </Col>
                                                </div>



                                            </Col>
                                            <Col span={12}>
                                                <Card title="Friendly URL">
                                                    <p>{window.location.origin}/{friendlyURL}</p>
                                                </Card>
                                            </Col>

                                            <Col span={24}>
                                                <div className="mb-2">
                                                    <Col className="mb-2">
                                                        JavaScript:
                                                    </Col>
                                                    <Col>
                                                        {/*<Form.Item*/}
                                                        {/*    name="script"*/}
                                                        {/*>*/}
                                                        {/*    <TextArea spellCheck={false} rows={window.screen.height >= 1000? 20:10}/>*/}
                                                        {/*</Form.Item>*/}
                                                        <Form.List
                                                            name="scripts"
                                                        >
                                                            {(fields, {add, remove}, {errors}) => (
                                                                <>
                                                                    {fields.map((field, index) => {

                                                                        let className = "jsTextarea-" + index;
                                                                        let length = javascriptCount.find((item) => item.className === className) && javascriptCount.find((item) => item.className === className).length;
                                                                        let status = javascriptCount.find((item) => item.className === className) && javascriptCount.find((item) => item.className === className).status;
                                                                        let maxLength = javascriptCount.find((item) => item.className === className) && javascriptCount.find((item) => item.className === className).maxLength;
                                                                        return (
                                                                            <Form.Item
                                                                                required={false}
                                                                                key={field.key}
                                                                            >
                                                                                <div className="row">
                                                                                    <div className="col-11">
                                                                                        <Form.Item
                                                                                            {...field}
                                                                                            style={{marginBottom: "7px"}}
                                                                                        >
                                                                                            <CodeMirror
                                                                                                className={"jsTextarea jsTextarea-" + index}
                                                                                                value=""
                                                                                                height={window.screen.height >= 1000 ? "500px" : "400px"}
                                                                                                extensions={[javascript()]}
                                                                                                onKeyUp={handleJavascriptCount}
                                                                                            />
                                                                                            {/*<TextArea*/}
                                                                                            {/*    className={"jsTextarea jsTextarea-" + index}*/}
                                                                                            {/*    onKeyUp={handleJavascriptCount}*/}
                                                                                            {/*    spellCheck={false}*/}
                                                                                            {/*    rows={window.screen.height >= 1000 ? 20 : 10}/>*/}
                                                                                        </Form.Item>
                                                                                        {
                                                                                            status !== "error" ? (
                                                                                                <Text
                                                                                                    type="secondary">{length}/{maxLength} Characters</Text>
                                                                                            ) : (
                                                                                                <Text
                                                                                                    type="danger">{length}/{maxLength} Characters</Text>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-1">
                                                                                        {fields.length > 1 ? (
                                                                                            <MinusCircleOutlined
                                                                                                className="dynamic-delete-button"
                                                                                                onClick={() => remove(field.name)}
                                                                                            />
                                                                                        ) : null}
                                                                                    </div>

                                                                                </div>
                                                                            </Form.Item>
                                                                        )
                                                                    })}
                                                                    <Form.Item>
                                                                        <Button
                                                                            type="dashed"
                                                                            onClick={() => add()}
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        >
                                                                            Add Javascript
                                                                        </Button>

                                                                    </Form.Item>
                                                                </>
                                                            )}
                                                        </Form.List>
                                                    </Col>
                                                </div>
                                            </Col>

                                        </Row>

                                    </Tabs.TabPane>
                                    {languageList.list.map((lang, index) => (
                                        <Tabs.TabPane tab={lang.code.toUpperCase() + " Detail"} key={"detail-" + index}
                                                      forceRender={true}>
                                            <Row gutter={[16, 16]}>
                                                <Col span={4}>
                                                    Title:
                                                </Col>
                                                <Col span={20}>
                                                    <Form.Item
                                                        name={"title-" + lang.code}
                                                        rules={[{required: true, message: "Title "+lang.code.toUpperCase()+" is required"}]}
                                                    >
                                                        <Input/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col span={4}>
                                                    Meta Descriptions:
                                                </Col>
                                                <Col span={20}>
                                                    <Form.Item name={"seoDescription-" + lang.code}>
                                                        <TextArea rows={5}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col span={4}>
                                                    Meta Keywords:
                                                </Col>
                                                <Col span={20}>
                                                    <Form.Item name={"seoKeyword-" + lang.code}>
                                                        <TextArea rows={5}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col span={4}>
                                                    Details:
                                                </Col>
                                                <Col span={20}>
                                                    <Form.Item name={"detail-" + lang.code}>
                                                        <CodeMirror
                                                            value=""
                                                            height={window.screen.height >= 1000 ? "500px" : "400px"}
                                                            extensions={[html()]}
                                                        />
                                                        {/*<TextArea spellCheck={false}*/}
                                                        {/*          rows={window.screen.height >= 1000 ? 20 : 10}/>*/}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Tabs.TabPane>
                                    ))}

                                </Tabs>
                            </Col>
                        ) : (languageList.status === 200) ? (
                            <Col className="mt-5">
                                <EmptyLanguage/>
                            </Col>
                        ) : ""
                        }


                    </Form>
                </div>
            </div>
        </>
    );


};



